import {
  ContentsSchema,
  GuestSchema,
  RoomObjectAclSchema,
} from '../../../definitions/schemas';
import {
  RoomObjectAclGuestType,
  RoomObjectAclType,
} from '../../../enums/RoomObjectAcl';
import { RoomStructureItemType } from '../../../enums/RoomStructureItemType';

export const buildEntryFromModel = (
  type: RoomObjectAclGuestType,
  guest?: GuestSchema
) =>
  ({
    guest,
    guestId: guest?.id,
    guestType: type,
    roomId: '',
    id: '',
  } as RoomObjectAclSchema);

export const getObjectAclsForContent = (
  contentId: string,
  contentType: string,
  objectAcls?: RoomObjectAclSchema[]
) =>
  (objectAcls || []).filter(
    (object) =>
      object.objectDataType === RoomObjectAclType.Content &&
      object.objectDataId === contentId &&
      contentType !== RoomStructureItemType.Header
  );

export const buildRoomObjectAclsFromContentIds = (content_ids?: string[]) =>
  (content_ids || []).map(
    (content_id) =>
      ({
        objectDataId: content_id,
        objectDataType: RoomObjectAclType.Content,
      } as RoomObjectAclSchema)
  );

// Filter out contents that have an acl
export const filterContentsWithoutAcl = (
  contents?: ContentsSchema,
  objectAcls?: RoomObjectAclSchema[]
) => {
  if (!objectAcls?.length) {
    return contents || [];
  }

  return (contents || []).filter(
    (content) =>
      !objectAcls?.some(
        (objectAcl) =>
          objectAcl.objectDataId === content.id &&
          objectAcl.objectDataType === RoomObjectAclType.Content
      )
  );
};
